'use client';
import { useAlert } from '@context/AlertContext';
import classNames from 'classnames';
import { useTranslation } from '@i18n/client';
import { Button } from '@components/Button';
import Modal from '@components/Modal/Modal';
import { WhatIsWrongModal } from '@components/Modal/WhatIsWrongModal';
import { useState } from 'react';
import ThemedIcon from '@components/ThemedIcon';

function AlertModal() {
  const { t } = useTranslation();
  const { alertState, close } = useAlert();
  const [childModalOpen, setChildModalOpen] = useState(false);

  const handleConfirm = () => {
    alertState.onConfirm && alertState.onConfirm();
    alertState.onClose && alertState.onClose();
    alertState.onSequenceClose && alertState.onSequenceClose();
    close();
  };

  const handleCancel = () => {
    alertState.onCancel && alertState.onCancel();
    alertState.onClose && alertState.onClose();
    alertState.onSequenceClose && alertState.onSequenceClose();
    close();
  };

  const handleClose = () => {
    alertState.onClose && alertState.onClose();
    alertState.onSequenceClose && alertState.onSequenceClose();
    close();
  };

  const handleChildModalOpen = () => {
    setChildModalOpen(true);
    close();
  };

  const handleChildModalClose = () => {
    setChildModalOpen(false);
    alertState.onSequenceClose && alertState.onSequenceClose();
    alertState.onClose && alertState.onClose();
  };

  const handleChildModalSubmitted = () => {
    setChildModalOpen(false);
  };

  return (
    <>
      {alertState.cancelWithModal && (
        <WhatIsWrongModal
          isOpen={childModalOpen}
          onClose={handleChildModalClose}
          onSubmitted={handleChildModalSubmitted}
        />
      )}
      <Modal isOpen={alertState.open} onClose={handleClose}>
        <div
          className={classNames(
            'relative mx-auto max-h-[90vh] w-full max-w-[340px] overflow-y-auto rounded-2xl bg-bg-secondary p-4 smd:p-4 md:min-w-[25rem]',
            {
              // 'md:w-[35rem]': alertState.type === 'confirm',
              // 'smd:max-w-[25rem]': alertState.type === 'alert',
              // 'smd:max-w-[35rem]': alertState.type === 'wideAlert',
            }
          )}
        >
          <button
            onClick={handleClose}
            className='absolute right-4 top-4 cursor-pointer'
          >
            <ThemedIcon
              name='circle-close'
              width={30}
              height={30}
              fill='#ffffff'
            />
          </button>
          <div className='mb-6 pr-[2.875rem] text-xl font-bold text-text-primary'>
            {alertState.message}
          </div>
          {alertState.description && (
            <div className='mb-6 whitespace-pre-line text-[16px] leading-[19px] text-text-primary'>
              {alertState.description}
            </div>
          )}
          {alertState.attentionMsg && (
            <p className='mb-6 whitespace-pre-line text-[16px] font-semibold leading-[19px] text-accent-primary'>
              {alertState.attentionMsg}
            </p>
          )}
          <div className={'flex flex-col items-center gap-4'}>
            <Button
              label={alertState.confirmButtonLabel || t('button.close')}
              classNameContainer='w-full'
              labelContainerClassName='break-words overflow-hidden'
              onClick={handleConfirm}
            />
            {alertState.type === 'confirm' && !alertState.hideCancellation && (
              <Button
                label={
                  alertState.cancelButtonLabel || t('button.cancelPayment')
                }
                variant='outlined'
                classNameContainer='order-1 w-full md:order-none'
                labelContainerClassName='break-words '
                onClick={
                  alertState.cancelWithModal
                    ? handleChildModalOpen
                    : handleCancel
                }
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AlertModal;
